import { render, staticRenderFns } from "./PlanBoard.vue?vue&type=template&id=8080e7a8&scoped=true&"
import script from "./PlanBoard.vue?vue&type=script&lang=js&"
export * from "./PlanBoard.vue?vue&type=script&lang=js&"
import style0 from "./PlanBoard.vue?vue&type=style&index=0&id=8080e7a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8080e7a8",
  null
  
)

export default component.exports